<template>
  <div class="donateBox">
    <!-- 全部项目列表 -->
    <div class="listBox">
      <div class="listTitle">
        <span class="titleText">我发起的一起捐（{{ totalNum }}）</span>
      </div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <ul class="projectList">
            <li class="projectItem" v-for="(item, i) in list" :key="i">
              <div class="projectDetail">
                <div class="imgBox">
                  <img :src="item.donated_cover" class="coverImg" />
                </div>
                <div class="contentBox">
                  <div class="itemTitle">{{ item.username }}</div>
                  <div class="itemDis">
                    {{ item.donated_info }}
                  </div>
                  <div class="itemNum">
                    <div class="itemNumLeft">
                      <div class="doneMoney">已捐</div>
                      <div class="moneyNum">
                        <span class="colorNum"
                          >{{ item.donated_money ? donated_money : 0 }}/</span
                        >{{ item.target_money ? item.target_money : "不限" }}
                      </div>
                    </div>
                    <div class="moneyNum">
                      <span class="colorNum">{{ item.jk_num }}</span
                      >笔
                    </div>
                  </div>
                </div>
              </div>
              <div class="sloganBox">
                <span class="solganTitle">口号：</span>
                {{ item.slogan }}
              </div>
              <div class="moreBox">
                <div class="moreBtn editBtn" @click="editItem(item)">编辑</div>
                <div class="moreBtn delBtn" v-if="item.jk_num == 0" @click="delItem(item)">删除</div>
                <div class="moreBtn" @click="goDetail(item.together_id)">
                  查看详情
                  <img src="../assets/right.png" class="rightIcon" />
                </div>
              </div>
            </li>
          </ul>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="bottomBox">
      共募捐 <span class="colorNum">{{ donated ? donated : 0 }}元</span>
    </div>

    <!-- 编辑一起捐弹窗 -->
    <van-popup v-model="showEdit" position="bottom" round get-container="body">
      <div class="editBox">
        <div class="editTitle">编辑一起捐</div>
        <van-field v-model="editForm.initiator" label="发起方" maxlength="15" placeholder="请输入发起方" />
        <van-field v-model="editForm.slogan" type="textarea" maxlength="150" label="口号" placeholder="请输入口号" />
        <van-field v-model="editForm.targetMoney" type="digit" maxlength="7" label="筹款目标(元)" placeholder="留空表示不限金额" />
        <div class="editBtns">
          <div class="editCancel" @click="showEdit=false">取消</div>
          <div class="editSubmit" @click="saveEdit">保存</div>
        </div>
      </div>
    </van-popup>

    <!-- 删除确认 -->
    <van-dialog
      v-model="showDel"
      title="确认删除"
      message="该一起捐尚未产生捐赠记录，删除后其分享主页将失效并跳转至项目详情页，确定删除吗？"
      show-cancel-button
      @confirm="confirmDel"
    />
  </div>
</template>

<script>
import { getMyLaunch, editTogether, delTogether } from "../api";
export default {
  name: "myDonate",

  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      //分页信息
      pageIndex: 0,
      totalNum: 10,
      donated: 0,
      //编辑弹窗
      showEdit: false,
      editForm: {
        together_id: "",
        initiator: "",
        slogan: "",
        targetMoney: "",
      },
      //删除确认
      showDel: false,
      delId: "",
    };
  },

  mounted() {},

  methods: {
    //获取项目列表
    async getList() {
      const res = await getMyLaunch(this.pageIndex);
      if (res.status == 200) {
        console.log(res, "res<<<<");
        this.totalNum = res.data.total;
        this.list = this.list.concat(res.data.data);
        this.refreshing = false;
        this.loading = false;
        this.donated = res.data.donated.toFixed(2);
      } else {
        this.$toast(res.err_msg);
      }
    },
    // 获取列表数据
    onLoad() {
      if (this.list.length < this.totalNum) {
        console.log(this.pageIndex, "第几页");
        this.pageIndex += 1;
        this.getList();
      } else {
        this.finished = true;
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageIndex = 1;
      this.list = [];
      this.getList();
    },
    //去往详情页面
    goDetail(id) {
      this.$router.push({ path: `/project/share?together_id=${id}` });
    },
    //打开编辑弹窗，填充当前项
    editItem(item) {
      this.editForm = {
        together_id: item.together_id,
        initiator: item.username,
        slogan: item.slogan,
        targetMoney: item.target_money == 0 ? "" : item.target_money,
      };
      this.showEdit = true;
    },
    //保存编辑
    async saveEdit() {
      if (!this.editForm.initiator.trim()) {
        this.$toast("请输入发起方");
        return;
      }
      if (!this.editForm.slogan.trim()) {
        this.$toast("请输入口号");
        return;
      }
      // 筹款目标：留空即视为不限金额(0)；填写则须为大于 0 的有效金额
      const raw = (this.editForm.targetMoney || "").trim();
      let target = 0;
      if (raw !== "") {
        const t = parseFloat(raw);
        if (isNaN(t) || t <= 0) {
          this.$toast("请输入有效的筹款目标金额");
          return;
        }
        target = t;
      }
      const params = {
        together_id: this.editForm.together_id,
        launch_name: this.editForm.initiator,
        slogan: this.editForm.slogan,
        target_money: target,
      };
      const res = await editTogether(params);
      if (res.status == 200) {
        this.$toast("修改成功");
        this.showEdit = false;
        this.refreshList();
      } else {
        this.$toast(res.err_msg);
      }
    },
    //点击删除（仅 jk_num=0 显示按钮）
    delItem(item) {
      this.delId = item.together_id;
      this.showDel = true;
    },
    //确认删除
    async confirmDel() {
      const res = await delTogether({ together_id: this.delId });
      if (res.status == 200) {
        this.$toast("删除成功");
        this.refreshList();
      } else {
        this.$toast(res.err_msg);
      }
    },
    //刷新列表
    refreshList() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 1;
      this.list = [];
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.donateBox {
  background-color: #f5f5f5;
  min-height: 100vh;
}
.listBox {
  width: 100%;
  padding: 55rem 40rem 100rem;
  background-color: #fff;
  .listTitle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 68rem;
    border-bottom: 1rem solid #e7e7e7;

    .titleText {
      font-size: 30rem;
      font-weight: 700;
      color: #b8211a;
    }

    .titleLine {
      width: 116rem;
      height: 4rem;
      background-color: #b8211a;
    }
  }

  .projectItem {
    width: 100%;
    padding: 30rem 0;
    border-bottom: 1px solid #e7e7e7;

    .projectDetail {
      display: flex;

      .imgBox {
        width: 216rem;
        height: 216rem;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 8rem;
        margin-right: 30rem;

        .coverImg {
          width: 100%;
        }
      }

      .contentBox {
        flex: 1;

        .itemTitle {
          width: 100%;
          font-size: 26rem;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          /*行数*/
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin-bottom: 20rem;
          font-weight: 600;
        }

        .itemDis {
          width: 100%;
          font-size: 24rem;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          /*行数*/
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin-bottom: 18rem;
          line-height: 38rem;
        }

        .itemNum {
          display: flex;
          justify-content: space-between;

          .itemNumLeft {
            display: flex;
            align-items: center;

            .doneMoney {
              width: 48rem;
              height: 30rem;
              text-align: center;
              line-height: 30rem;
              border-radius: 8rem;
              color: #f79d01;
              font-size: 18rem;
              border: 1rem solid #f79d01;
              margin-right: 10rem;
            }
          }

          .moneyNum {
            font-size: 24rem;
            color: #3c3c3c;
            font-weight: 600;
          }
        }
      }
    }
  }
}

.moreBox {
  margin-top: 20rem;
  display: flex;
  justify-content: flex-end;
  gap: 20rem;

  .moreBtn {
    width: 120rem;
    height: 40rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16rem;
    color: #b8211a;
    background-color: #fff;
    border: 1px solid #b8211a;
    border-radius: 8rem;

    .rightIcon {
      width: 7rem;
      height: 13rem;
      margin-left: 10rem;
    }
  }

  .editBtn {
    color: #fff;
    background-color: #b8211a;
    border-color: #b8211a;
  }
}
.sloganBox {
  display: flex;
  align-items: center;
  font-size: 22rem;
  color: #5d5d5d;
  margin-top: 35rem;
  .solganTitle {
    font-weight: 600;
    color: #000;
  }
}
.bottomBox {
  padding: 30rem 0 100rem;
  font-size: 22rem;
  text-align: center;
  color: #999999;
}
.colorNum {
  color: #b8211a;
}
.editBox {
  background: #fff;
  padding: 30rem 40rem 60rem;
  .editTitle {
    font-size: 32rem;
    font-weight: 700;
    text-align: center;
    color: #121212;
    padding: 20rem 0 30rem;
  }
  ::v-deep .van-field {
    border-bottom: 1px solid #e7e7e7;
  }
  ::v-deep .van-field__label {
    width: 160rem;
    font-size: 26rem;
    font-weight: 700;
    color: #000;
  }
  ::v-deep .van-field__control {
    font-size: 24rem;
    color: #333;
  }
  .editBtns {
    display: flex;
    margin-top: 40rem;
    .editCancel,
    .editSubmit {
      flex: 1;
      height: 82rem;
      line-height: 82rem;
      text-align: center;
      font-size: 30rem;
      border-radius: 8rem;
    }
    .editCancel {
      color: #606060;
      background: #f0f0f0;
      margin-right: 20rem;
    }
    .editSubmit {
      color: #fff;
      background: #b8211a;
    }
  }
}
</style>
